define('OutSystems/ClientRuntime/VersionDefinition',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.toObject = exports.registerPackage = exports.clientRuntimeKey = void 0;
    var versions = new Map();
    exports.clientRuntimeKey = "Client Runtime Packages";
    var cacheResult;
    function registerPackage(project, version) {
        cacheResult = null;
        versions.set(project, version);
    }
    exports.registerPackage = registerPackage;
    function toObject() {
        if (!cacheResult) {
            var result_1 = { "Client Runtime Packages": "" };
            versions.forEach(function (version, project) {
                if (version && project) {
                    result_1[exports.clientRuntimeKey] += "".concat(project, "= ").concat(version, ";");
                }
            });
            cacheResult = result_1;
        }
        return cacheResult;
    }
    exports.toObject = toObject;
});
//# sourceMappingURL=VersionDefinition.js.map;
